/* eslint-disable no-shadow */
/* eslint-disable max-len */
import {
  useState, useCallback, useEffect,
} from 'react';
import useToastNotification from 'hooks/useToastNotification';
import { OptionType } from 'components/atoms/Select';
import { HopeShiftDomain } from 'domain/master/general/hopeShift';

import { useFormik } from 'formik';
import ShiftPatternDomain, { ShiftPattern } from 'domain/master/attend/shiftPattern';
import { getAvailableShiftPattern } from 'api/shiftPattern';
import { ContextMenuType } from 'components/molecules/ContextMenu/type';
import { getHopeShiftList, postHopeShifts } from 'api/hopeShift';

const listHours = [
  '-', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
  '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
  '20', '21', '22', '23',
];
const listTimes = [
  '-', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
  '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
  '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
  '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
  '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',

];

export const useHopeShift = () => {
  const [hourFormOptions, setHourFormOptions] = useState<Array<OptionType>>([]);
  const [timeFormOptions, setTimeFormOptions] = useState<Array<OptionType>>([]);

  useEffect(() => {
    //
    setHourFormOptions(listHours.map((Hours) => ({
      value: Hours,
      label: Hours,
    })));

    //
    setTimeFormOptions(listTimes.map((Hours: any) => ({
      value: Hours,
      label: Hours,
    })));
  }, []);

  return {
    hourFormOptions,
    timeFormOptions,
  };
};

export const useHopeShiftList = () => {
  const [hopeShiftList] = useState<Array<HopeShiftDomain>>([]);
  const [orgCode, setOrgCode] = useState(sessionStorage.getItem('selectedOrgCodeStaffMaster') || sessionStorage.getItem('loginUser.orgCode')!);
  const [employmentId, setEmploymentId] = useState(sessionStorage.getItem('selectedEmploymentIdStaffMaster') || '');
  const [date, setDate] = useState<Date>(new Date(sessionStorage.getItem('hopeShift.targetDate') || new Date()));
  const [blocking, setBlocking] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [contextMenus, setContextMenus] = useState<ContextMenuType[]>([]);
  const { successNotification, errorNotification } = useToastNotification();
  const [shiftPatternList, setShiftPatternList] = useState<Array<ShiftPatternDomain>>([]);

  const onSubmit = async (val: HopeShiftDomain[]) => {
    if (!confirmModalOpen) {
      setConfirmModalOpen(true);
      return;
    }
    setConfirmModalOpen(false);
    const changedShift = val.filter((item) => item.fixStatus === 9);
    if (changedShift.length > 0) {
      setBlocking(true);
      postHopeShifts(changedShift).then((response: Array<any>) => {
        fetchData();
        successNotification('登録しました。');
        // 削除後にデータを再取得
        setBlocking(false);
        setDate(date);
      }).catch((error) => {
        setBlocking(false);
        if (error.response && error.response.data && error.response.data.errors) {
          let msgError = '';
          error.response.data.errors.map((item: { defaultMessage: string; }) => {
            msgError += `${item.defaultMessage} \n`;
            return msgError;
          });
          errorNotification(msgError);
        } else {
          errorNotification('サーバー側でエラーが発生しました。');
        }
      });
    } else {
      errorNotification('提出可能希望シフトがありません。');
    }
  };

  const formik = useFormik({
    initialValues: hopeShiftList,
    onSubmit,
  });

  // Get list staff
  const fetchData = useCallback(async () => {
    setBlocking(true);
    const shiftList = await getHopeShiftList(
      sessionStorage.getItem('loginUser.orgCode') || '',
      date,
    );

    const hopeShiftLst = shiftList.map((shift) => {
      const hopeShift: HopeShiftDomain = new HopeShiftDomain({
        createUser: sessionStorage.getItem('loginUser.staffCode') || '',
        updateUser: sessionStorage.getItem('loginUser.staffCode') || '',
        hopeShiftId: shift.hopeShiftId,
        orgCode: shift.orgCode || sessionStorage.getItem('loginUser.orgCode') || '',
        staffCode: shift.staffCode || sessionStorage.getItem('loginUser.staffCode') || '',
        targetDate: shift.targetDate,
        hopeShiftPatternType: shift.hopeShiftPatternType,
        shiftPatternId: shift.shiftPatternId,
        startTime: shift.startTime,
        endTime: shift.endTime,
        note: shift.note,
        fixStatus: shift.fixStatus,
        holidayName: shift.holidayName,
        employmentId: shift.employmentId,
        distinctionHoliday: shift.distinctionHoliday,
        useHoliday: shift.useHoliday,
      });
      return hopeShift;
    });
    formik.setValues(hopeShiftLst);
    setBlocking(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  useEffect(() => {
    getAvailableShiftPattern(formik.values[0]?.orgCode || sessionStorage.getItem('loginUser.orgCode')!).then((shiftPatterns) => {
      // Set up shift pattern list
      const shiftPatternList = shiftPatterns.map((item: ShiftPattern) => new ShiftPatternDomain(item));
      setShiftPatternList(shiftPatternList);
      const subMenuButtons: ContextMenuType[] = shiftPatternList.map((item) => {
        const subMenuButton: ContextMenuType = {
          isRed: false,
          isSelectable: true,
          label: item.shiftPatternNameDisp,
          isHidden: false,
          stamptype: 0,
          onClick: () => {
          // setSessionStorage(stampAmendmentButton.link, stampAmendmentButton.stamptype);
          },
        };
        return subMenuButton;
      });
      const contextMenuCantWork: ContextMenuType = {
        isRed: false,
        isSelectable: true,
        label: '出勤できません',
        isHidden: false,
        subMenu: undefined,
        stamptype: 0,
        onClick: () => {
        // setSessionStorage(stampAmendmentButton.link, stampAmendmentButton.stamptype);
        },
      };
      const contextMenuShiftPattern: ContextMenuType = {
        isRed: false,
        isSelectable: false,
        label: 'シフトパターン',
        showSearchBox: true,
        isHidden: false,
        subMenu: subMenuButtons,
        stamptype: 0,
        onClick: () => {
        // setSessionStorage(stampAmendmentButton.link, stampAmendmentButton.stamptype);
        },
      };

      setContextMenus([contextMenuCantWork, contextMenuShiftPattern]);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values[0]?.employmentId, formik.values[0]?.orgCode]);

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);


  return {
    formik,
    fetchData,
    employmentId,
    setEmploymentId,
    orgCode,
    setOrgCode,
    date,
    setDate,
    blocking,
    confirmModalOpen,
    closeConfirmModal,
    contextMenus,
    shiftPatternList,
  };
};

export default useHopeShiftList;
